import script from "./OtpVerification.vue?vue&type=script&setup=true&lang=js"
export * from "./OtpVerification.vue?vue&type=script&setup=true&lang=js"

import "./OtpVerification.vue?vue&type=style&index=0&id=51bdc6ec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51bdc6ec"]])

export default __exports__